module.exports = "<a :skin=skins.buttons :title=fdata.title style=\"height: auto\" target=_blank :href=fdata.url :text=fdata.title class=\"Button Button--primary\"><span class=Button__text>{{ fdata.title }}</span></a>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/buttons/link.vue
// module id = 437
// module chunks = 0